export default "/_next/static/images/1a222ed412408eb301cbeb3f0708a378.svg";